import { useStoreMap } from 'effector-react'
import { useState } from 'react'
import { supportModel } from '~/widgets/Support'
import { Content } from '~/widgets/Support/ui/styled'
import { Card, TitleWrapper, Title } from '~/widgets/Support/ui/styled'
import { CmsBlockAttributes } from '~/shared/api'
import { SupportCmsBlockEnum } from '~/shared/config/enums'
import { DrawerComponent, useDrawer } from '~/shared/ui/Drawer'
import { ChevronRightIcon } from '~/shared/ui/icons'

type RoadAccidentDrawerProps = {
  isShow: boolean
  onClose: () => void
}

export function RoadAccidentDrawer({
  isShow,
  onClose,
}: RoadAccidentDrawerProps) {
  const [isRoadAccidentShow, roadAccidentOpen, roadAccidentClose] = useDrawer()

  const [isDrawerShow, openDrawer, closeDrawer] = useDrawer()

  const [selectedSupport, setSelectedSupport] =
    useState<CmsBlockAttributes | null>()

  const supports = useStoreMap(supportModel.$supports, (support) =>
    (support || [])?.map((support) => ({
      ...support.getAttributes(),
      id: support.getApiId() as UniqueId,
    })),
  )

  const europeanProtocolSupport = (supports || []).find(
    ({ position }) => position === SupportCmsBlockEnum.EUROPEAN_PROTOCOL,
  )

  const roadAccidentSupports = (supports || []).filter(
    ({ position }) => position === SupportCmsBlockEnum.ROAD_ACCIDENT,
  )

  const handleSelectSupportOpen = (support: CmsBlockAttributes) => {
    setSelectedSupport(support)
    openDrawer()
  }

  return (
    <>
      <DrawerComponent isShow={isShow} onCancel={onClose}>
        {!roadAccidentSupports?.length && !europeanProtocolSupport && (
          <>Контент не найден</>
        )}

        {!!roadAccidentSupports?.length && (
          <Card onClick={roadAccidentOpen}>
            <TitleWrapper>
              <Title style={{ marginLeft: '12px' }}>
                Вы стали участником ДТП, что делать?
              </Title>
            </TitleWrapper>
            <ChevronRightIcon />
          </Card>
        )}
        {!!europeanProtocolSupport && (
          <Card
            onClick={() => handleSelectSupportOpen(europeanProtocolSupport)}
          >
            <TitleWrapper>
              <Title style={{ marginLeft: '12px' }}>
                {europeanProtocolSupport.previewContent}
              </Title>
            </TitleWrapper>
            <ChevronRightIcon />
          </Card>
        )}
      </DrawerComponent>

      <DrawerComponent isShow={isRoadAccidentShow} onCancel={roadAccidentClose}>
        {roadAccidentSupports.map((support) => (
          <Card
            key={support.id}
            onClick={() => handleSelectSupportOpen(support)}
          >
            <TitleWrapper>
              <Title style={{ marginLeft: '12px' }}>
                {support.previewContent}
              </Title>
            </TitleWrapper>
            <ChevronRightIcon />
          </Card>
        ))}
      </DrawerComponent>

      <DrawerComponent isShow={isDrawerShow} onCancel={closeDrawer}>
        <Content
          dangerouslySetInnerHTML={{
            __html: selectedSupport?.content || 'Контент не найден',
          }}
        />
      </DrawerComponent>
    </>
  )
}
